export const repairs_table_display = {
  empty: "No repairs found",
  col_created_at: "Created",
  col_org: "Organization",
  col_part_to_repair: "Part to repair",
  col_shop: "Shop",
  col_status: "Status",
  status_open: "Open",
  status_closed: "Closed",
};
